import { render, staticRenderFns } from "./DbpyL_Search.vue?vue&type=template&id=50f00ed1"
import script from "./DbpyL_Search.vue?vue&type=script&lang=js"
export * from "./DbpyL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports